import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { fileUrl } from "@/lib/api";

export function PhotoCarousel({ photos, alt }) {
  const [idx, setIdx] = useState(0);
  const [touchX, setTouchX] = useState(null);
  const n = photos.length;
  const go = (d) => setIdx((i) => (i + d + n) % n);

  if (!n) {
    return <div className="h-64 sm:h-full sm:min-h-[420px] bg-ivory-alt" />;
  }

  return (
    <div
      data-testid="photo-carousel"
      className="relative h-64 sm:h-full sm:min-h-[420px] w-full select-none overflow-hidden bg-ivory-alt"
      onTouchStart={(e) => setTouchX(e.touches[0].clientX)}
      onTouchEnd={(e) => {
        if (touchX != null && Math.abs(e.changedTouches[0].clientX - touchX) > 40) {
          go(e.changedTouches[0].clientX < touchX ? 1 : -1);
        }
        setTouchX(null);
      }}
    >
      <img data-testid="carousel-photo" src={fileUrl(photos[idx])} alt={alt} className="h-full w-full object-cover" draggable={false} />

      {n > 1 ? (
        <>
          <button
            data-testid="carousel-prev-btn"
            onClick={() => go(-1)}
            aria-label="Previous photo"
            className="absolute left-3 top-1/2 -translate-y-1/2 flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-ink shadow-md hover:bg-white transition-colors duration-200"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            data-testid="carousel-next-btn"
            onClick={() => go(1)}
            aria-label="Next photo"
            className="absolute right-3 top-1/2 -translate-y-1/2 flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-ink shadow-md hover:bg-white transition-colors duration-200"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
          <div data-testid="carousel-dots" className="absolute bottom-3 left-1/2 flex -translate-x-1/2 items-center gap-1.5 rounded-full bg-ink/40 px-3 py-1.5 backdrop-blur-sm">
            {photos.map((_, i) => (
              <button
                key={i}
                data-testid={`carousel-dot-${i}`}
                onClick={() => setIdx(i)}
                aria-label={`Photo ${i + 1}`}
                className={`h-1.5 w-1.5 rounded-full transition-all duration-200 ${i === idx ? "bg-white w-4" : "bg-white/50"}`}
              />
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}
